import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Modal, Button, Input, Upload, Icon, message } from 'antd';
import { subscribe } from 'alfa';

import JWK from '../../helpers/jwk';
import Security from '../../helpers/security';

const KeyAdder = ({ set, form, user, keyAdderVisible }) => {
  const [file, setFile] = useState(null);
  const [skip, setSkip] = useState(false);

  const close = () => {
    setSkip(true);
    set('keyAdderVisible', false);
  };

  const loadKey = (event) => {
    if (event.file.status === 'removed') {
      setFile(null);
      return;
    }

    const fileReader = new FileReader();
    fileReader.onloadend = (reader) => {
      setFile(reader.currentTarget.result);
    };

    fileReader.readAsText(event.file);
  };

  const confirm = () => {
    form.validateFieldsAndScroll(async (errors, values) => {
      if (errors) {
        return;
      }

      const pass = values.password;
      const encrypted = JSON.parse(file);
      try {
        await JWK.decrypt(encrypted, pass);
        Security.registerKey(user.getData(), file);
        Modal.success({
          title: 'Key add successfully!',
          content: (
            <p>
              {'Your key was added to our vault, but don\'t worry, it\'s encrypted there!'}
              <br />
              {'When making trasactions, we\'ll ask for your password to momentarily enroll your key and sign the request.'}
            </p>
          ),
        });
        close();
      } catch (error) {
        console.error('ERROR: KeyAdder: JWK.decrypt()', error); // eslint-disable-line no-console
        message.error('Error decrypting your key.');
      }
    });
  };

  useEffect(() => {
    if (keyAdderVisible || skip || user.requiresLogin()) {
      return;
    }

    const keys = (user.getData().public_keys || []).filter((key) => !key.disabled_at || key.disabled_at === '');

    if (!Security.hasKey(user.getData()) && keys.length > 0) {
      set('keyAdderVisible', true);
    }
  }, [user, skip, keyAdderVisible, set]);

  const { getFieldDecorator } = form;
  return (
    <Modal
      title="Upload your b2b key"
      visible={keyAdderVisible}
      closable={false}
      width={500}
      footer={[
        <Button key="cancel" onClick={close}>
          Skip
        </Button>,
        <Button key="upload" type="primary" onClick={confirm}>
          Confirm
        </Button>,
      ]}
    >
      <p>
        In order to make transaction, you&apos;ll need to upload your previously
        created <strong>b2b.key</strong>. This file was created and
        automatically downloaded when you created your <strong>password</strong>
        .
      </p>
      <p>Without this file you will not be able to create moviments on your accounts, in this case contact the administrator.</p>
      <Form layout="vertical">
        <Form.Item>
          {getFieldDecorator('key', {
            rules: [
              {
                required: true,
                message: 'Please add your key',
              },
            ],
          })(
            <Upload type="drag" listType="text" beforeUpload={() => false} multiple={false} onChange={loadKey}>
              <p className="ant-upload-drag-icon">
                <Icon type="key" />
              </p>
              <p>
                Click or drag the <strong>b2b.key</strong> file to this area
              </p>
            </Upload>,
          )}
        </Form.Item>
        <Form.Item label="Password" required>
          {getFieldDecorator('password', {
            rules: [
              {
                required: true,
                message: 'Please input your password!',
              },
            ],
          })(<Input prefix={<Icon type="key" />} type="password" onPressEnter={confirm} autoFocus />)}
        </Form.Item>
      </Form>
    </Modal>
  );
};

KeyAdder.propTypes = {
  form: PropTypes.shape({
    validateFieldsAndScroll: PropTypes.func,
    getFieldDecorator: PropTypes.func,
  }),
  keyAdderVisible: PropTypes.any,
  set: PropTypes.func,
  user: PropTypes.shape({
    getData: PropTypes.func,
    requiresLogin: PropTypes.func,
  }),
};

export default subscribe(Form.create({ name: 'form-key-adder' })(KeyAdder), ['set', 'keyAdderVisible', 'user'], ['keyAdderVisible']);
